import { Checkbox, Col, Row } from "antd";

import React, { useEffect, useState } from "react";
import { useTheme } from "../../../Styles/ThemeHook";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import {
    rooms
} from "../../../ViewFragments/SearchResults/Sider/TopBarFilters/options"
import ButtonGroup from "../ButtonGroup/web";
import { Switch } from "src/Components/Swicth/web";
import { useFilters } from "../Filters.hook";

export const Rooms = ({ collapsable = false, inputType = "checkbox", filterChanged, triggerApplyFilter = undefined, show = false }) => {
	if (!show) return null;

	const { theme } = useTheme();
	const { filters } = useFilters();
	let filter = null;
	const [usingExactMode, setUsingExactMode] = useState<boolean>(filters?.bedroomsExactMode ?? false);
	const [currentValue, setCurrentValue] = useState(filters?.rooms ?? []);

	const normalizeFilterValues = (values) => {
		if (!Array.isArray(values)) return [];
		return values
			.map(item => (item && typeof item === "object" ? item.value : item))
			.filter(item => item !== undefined && item !== null);
	};

	const arraysAreEqual = (first = [], second = []) => {
		if (first === second) return true;
		if (first.length !== second.length) return false;
		return first.every((item, index) => second[index] === item);
	};

	useEffect(() => {
		const roomsValue = normalizeFilterValues(filters?.rooms);
		const normalizedCurrent = normalizeFilterValues(currentValue);

		if (!arraysAreEqual(roomsValue, normalizedCurrent)) {
			setCurrentValue(roomsValue);
		}

		const exactModeValue = filters?.bedroomsExactMode ?? false;
		if (exactModeValue !== usingExactMode) {
			setUsingExactMode(exactModeValue);
		}
	}, [filters?.rooms, filters?.bedroomsExactMode]);

	const handleChange = value => {
		const rawValues = Array.isArray(value)
			? value
			: value === undefined || value === null
				? []
				: [value];
		const sanitizedValues = rawValues.filter(item => item !== undefined && item !== null);

		if (sanitizedValues.length === 0) {
			handleClearFilter();
			return;
		}

		const valueSet = new Set(sanitizedValues.map(item => String(item)));
		const selectedOptions = rooms.filter(option => valueSet.has(String(option.value)));

		if (selectedOptions.length === 0) {
			handleClearFilter();
			return;
		}

		const selectedValues = selectedOptions.map(option => option.value);
		const dataOptions = selectedOptions.map(option => ({
			text: usingExactMode ? option.text : option.text.replace(/ambientes/, 'o más ambientes'),
			value: option.value
		}));

		setCurrentValue(selectedValues)
		handleApplyFilter({ rooms: dataOptions, bedroomsExactMode: { text: null, value: usingExactMode } });
	};

	const handleClearFilter = () => {
		if (currentValue.length === 0 && usingExactMode === false) {
			handleApplyFilter({ rooms: [], bedroomsExactMode: { text: null, value: false } })
			return;
		}

		setCurrentValue([]);
		setUsingExactMode(false);
		handleApplyFilter({ rooms: [], bedroomsExactMode: { text: null, value: false } })
	}

	const handleExactChange = (value) => {
		setUsingExactMode(value);
		handleApplyFilter({ bedroomsExactMode: {text: null, value} })

		if (!value) {
			handleClearFilter();
		};
	}

	const handleApplyFilter = (filter) => {
        if (triggerApplyFilter) triggerApplyFilter(filter);
        else filterChanged(filter)
    }

	if (inputType === "checkbox") {
		filter = (
			<Checkbox.Group value={currentValue} onChange={handleChange}>
				<Row gutter={[0, theme.spacing.lgSpacing]}>
					{rooms?.map(room => (
						<Col span={24} key={`key_${room.value}_rooms`}>
							<Checkbox value={room.value}>{room.text}</Checkbox>
						</Col>
					))}
				</Row>
			</Checkbox.Group>
		);
	} else if (inputType === "buttonGroup") {
		filter = (
			<>
				<div className="filter__scrollable-box">
					<ButtonGroup
						options={rooms.map(option => {return {text: option.smallText, value: option.value}})}
						selected={currentValue}
						allowMuliple={usingExactMode}
						onChange={handleChange} 
						cleanFilter={handleClearFilter}
						optionForAny={{text: 'Todos', value: null}} 
						exactMode={usingExactMode}
					/>
				</div>

				<div className="filter__exact-mode">
					<span>Número exacto de ambientes</span>
					<Switch checked={usingExactMode} onChange={handleExactChange} />
				</div>

				<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
			</>
		);
	};

	return (
		<div className={"filter rooms-filter"}>
			{collapsable ?
				<IC_Collapse label="Ambientes" isActive={currentValue?.length >= 1} startOpen={currentValue?.length >= 1}>
					{filter}
				</IC_Collapse> :
				<>
					{inputType === "buttonGroup" && <h3 className="filter-title">Ambientes</h3>}
					{filter}
				</>
			}
		</div>
	);
};
